module.exports = __webpack_public_path__ + "static/media/34.a927192b.png";